import seatDlg from "./seatDlg.js";
import areaDlg from "./areaDlg.js";
import subjectDlg from "./subjectDlg.js";

const customerCenter = {
  namespaced: true,
  modules: {
    seatDlg,
    areaDlg,
    subjectDlg
  }
};

export default customerCenter;
